
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[funnel]",
      function () {
        return require("private-next-pages/[funnel]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[funnel]"])
      });
    }
  